export const encoded = (str: string) => encodeURIComponent(str);

export const decoded = (str: string) => decodeURIComponent(str);

export function base64Encode(str: string) {
  return window.btoa(unescape(encodeURIComponent(str)));
}
export function base64Decode(str: string) {
  return decodeURIComponent(escape(window.atob(str)));
}
